module.exports = __webpack_public_path__ + "img/new-dapps-page.7b4b22d1.jpg";